module.exports = __webpack_public_path__ + "static/media/people.2f4bb248.svg";